class PhoneNumberInput {
    constructor(phonePrefixes, modalID = null) {
        this.initCountrySelect(modalID);
        this.resizeCountrySelect();
        this.removePhonePrefixFromInput(phonePrefixes);
    }
    initCountrySelect(modalID){
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.element.getAttribute('prefix') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        if(modalID){
            let parent =  $('#'+modalID);
            $('.phone-number-input-group select[name=Country]').select2({
                placeholder: "Select an option",
                templateSelection: tagFormat,
                templateResult: optionFormat,
                dropdownParent: parent,
                dropdownCssClass : 'phone-number-input-group'
            });
        } else {
            $('.phone-number-input-group select[name=Country]').select2({
                placeholder: "Select an option",
                templateSelection: tagFormat,
                templateResult: optionFormat,
                dropdownCssClass : 'phone-number-input-group'
            });
        }
    }
    resizeCountrySelect(){
        const width = $('.phone-number-input-group').width();
        $('<style>.select2-dropdown.phone-number-input-group { width: '+width+'px !important; }</style>').appendTo('body');
    }
    removePhonePrefixFromInput(phonePrefixes){
        const thisClass = this;
        const phonePrefixesArr = [];
        let typingTimer;
        const inputTel = $('.phone-number-input-group input[name=PhoneNumber]');
        for(const i in phonePrefixes){
            phonePrefixesArr.push(phonePrefixes[i]);
        }

        thisClass.doneTypingTelInput(phonePrefixesArr, phonePrefixes, inputTel.val());

        inputTel.bind("change",function(){
            thisClass.doneTypingTelInput(phonePrefixesArr, phonePrefixes, $(this).val());
        });

        inputTel.on('keyup', function () {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                thisClass.doneTypingTelInput(phonePrefixesArr, phonePrefixes, $(this).val());
            }, 1000);
        });
    }
    doneTypingTelInput(phonePrefixesArr, phonePrefixes, inputValue){
        const thisClass = this;
        const phonePrefix = phonePrefixesArr.filter(a => inputValue.includes(a));
        if(phonePrefix.length === 1){
            $('.phone-number-input-group input[name=PhoneNumber]').val(inputValue.replace(phonePrefix, ""));
            $('.phone-number-input-group select[name=Country]').val(thisClass.getCountryIDByPhonePrefix(phonePrefixes, phonePrefix[0])).trigger('change');
        } else if(phonePrefix.length > 1){
            const longestMatchPrefix = phonePrefix.reduce(
                function (a, b) {
                    return a.length > b.length ? a : b;
                }
            );
            $('.phone-number-input-group input[name=PhoneNumber]').val(inputValue.replace(longestMatchPrefix, ""));
            $('.phone-number-input-group select[name=Country]').val(thisClass.getCountryIDByPhonePrefix(phonePrefixes, longestMatchPrefix)).trigger('change');
        }
    }
    getCountryIDByPhonePrefix(phonePrefixes, phonePrefix){
        for (const i in phonePrefixes){
            if(phonePrefixes[i] === phonePrefix){
                return i;
            }
        }
        return null;
    }
}
window.PhoneNumberInput = PhoneNumberInput;